export interface EricErrorRoute {
    path: string;
    queryParams?: {
        [key: string]: any;
    };
}

export interface EricErrorConfig {
    route: EricErrorRoute;
    ids: string[];
}

const attachmentsRoute = {
  path: 'attachments',
  queryParams: {}
};

const salesTaxRoute = {
    path: 'umsatzsteuer-angaben',
    queryParams: {}
};

const profitDeterminationRoute = {
    path: 'gewinnermittlung-angaben',
    queryParams: {}
};

const prepaymentRoute = {
    path: 'festsetzung-vorauszahlung-angaben',
    queryParams: {}
};

const incomeTaxRoute = {
    path: 'lohnsteuer-angaben',
    queryParams: {}
};

const commercialRegisterEntryRoute = {
    path: 'handelsregistereintrag-angaben',
    queryParams: {}
};

const formOfIncorporationRoute = {
    path: 'gruendungsform-angaben',
    queryParams: {}
};

const companyRoute = {
    path: 'unternehmen-angaben',
    queryParams: {}
};

const diffManagementRoute = {
    path: 'abweichender-ort-geschaeftsleitung-angaben',
    queryParams: {}
};

const currentOperationalRatioRoute = {
    path: 'bisherige-betriebliche-verhaeltnisse-angaben',
    queryParams: {}
};

const authorizedRecipientRoute = {
    path: 'empfangsbevollmaechtigter-angaben',
    queryParams: {}
};

const taxConsultingRoute = {
    path: 'steuerliche-beratung-angaben',
    queryParams: {}
};

const partnershipRoute = {
    path: 'partnerschafts-angaben',
    queryParams: {}
};

const bankDetailsRoute = {
    path: 'bankverbindung-angaben',
    queryParams: {}
};

const operatingSitesRoute = {
    path: 'betriebstaetten-angaben',
    queryParams: {}
};

const personalRoute = {
    path: 'personen-angaben',
    queryParams: {}
};

const organizationsRoute = {
    path: 'organschaft-angaben',
    queryParams: {}
};

const telNumberIds = ['#vorwahlInternational0',
    '#vorwahlInternational1',
    '#vorwahlNational0',
    '#rufnummer0',
    '#vorwahlNational1',
    '#rufnummer1'];

const addressIds = ['#inlandsadresseStrasse',
    '#inlandsadressePostleitzahl',
    '#inlandsadresseOrt'];

const internationalAddressIds = ['#auslandsadressePostleitzahl',
    '#auslandsadresseOrt',
    '#auslandsadresseLand'];

const bankIds = ['#iban0', '#iban1'];

const poBoxIds = ['#postfachadressePostfach',
    '#postfachadressePostleitzahl',
    '#postfachadresseOrt'];

const personIds = ['#vorname',
    '#nachname',
    '#geburtsdatum',
    '#religionsschluessel'];

const smallBusinessNotSet = 'Der auf einen Jahresgesamtumsatz hochgerechnete voraussichtliche' +
    ' Umsatz im Gründungsjahr übersteigt nicht die Grenze des § 19 Absatz 1 UStG. Es wurden' +
    ' jedoch keine Angabe im Feld Umsatzsteuer/KleinunternehmerRegelung/KleinUnternUSt' +
    ' beziehungsweise Umsatzsteuer/KleinunternehmerRegelung/KleinUnternUStVerzicht gemacht.';

const smallBusinessNotValid = 'Der auf einen Jahresgesamtumsatz hochgerechnete' +
    ' voraussichtliche Umsatz im Gründungsjahr übersteigt die Grenze des § 19 Absatz 1 UStG.' +
    ' Die Kleinunternehmerregelung kann daher weder in Anspruch genommen werden noch kann darauf' +
    ' ein Verzicht erklärt werden.';

const sollIstTax = 'Der auf einen Jahresgesamtumsatz hochgerechnete voraussichtliche Umsatz im' +
    ' Gründungsjahr übersteigt die Grenze des § 19 Absatz 1 UStG oder es wurde auf die Inanspruchnahme' +
    ' der Kleinunternehmer-Regelung verzichtet. Bitte geben Sie im Feld' +
    ' Umsatzsteuer/SollIstVersteuerung/AuswahlSollIstVerst an, ob' +
    ' Sollversteuerung oder Istversteuerung angewendet werden soll.';

const invalidSollIstSmallBusiness = 'Angaben zur Soll- / Istversteuerung dürfen nur gemacht' +
    ' werden, wenn im Feld Umsatzsteuer/KleinunternehmerRegelung/KleinUnternUSt die Anwendung der' +
    ' Kleinunternehmerregelung (§ 19 Absatz 1 UStG) nicht bejaht wurde.';

const emptyFoundingYearSales = 'Bitte machen Sie Angaben im Feld Umsatzsteuer/GesUmsatz/GruendJahr.';

const emptyNextYearSales = 'Bitte machen Sie Angaben im Feld Umsatzsteuer/GesUmsatz/FolgeJahr.';

const salesTaxFreeType = 'Bitte machen Sie Angaben im Feld Umsatzsteuer/Steuerbefreiung/UmsatzArt.';

const salesTaxReducedType = 'Bitte machen Sie Angaben im Feld Umsatzsteuer/ErmSteuersatz/UmsatzArt.';

const invalidTaxLiability = 'Es wurde die Erteilung eines Nachweises zur Steuerschuldnerschaft des' +
    ' Leistungsempfängers bei Bau- und / oder Gebäudereinigungsleistungen beantragt, jedoch keine' +
    ' Angabe zum Umfang der Bau- und / oder Gebäudereinigungsleistungen gemacht.';

const averageTaxation = 'Bitte machen Sie Angaben im Feld Umsatzsteuer/Durchschnittbesteuerung/UmsatzArt.';

const emptyOldAddress = 'Es wurden Angaben im Feld EinzelU/BisherigeVerhaeltnisse/ZugezogenAm gemacht.' +
    ' Bitte machen Sie auch Angaben zur früheren Anschrift.';

const profitDeterminationType = 'Bitte machen Sie Angaben im Feld Betrieb/GewinnErmittlgsAngaben/GewinnErmittlung.';

const emptyDeviatedYear = 'Es wurde ein abweichendes Wirtschaftsjahr eingegeben. Bitte machen Sie auch' +
    ' Angaben im Feld Betrieb/GewinnErmittlgsAngaben/AbwWJ_ab.';

const invalidDeviatedYear = 'Das im Feld Betrieb/GewinnErmittlgsAngaben/AbwWJ_ab eingegebene' +
    ' Datum darf nicht auf den Januar fallen.';

const prepaymentNextYear = 'Bitte machen Sie Angaben in mindestens einem der folgenden Felder:' +
    ' Betrieb/FestsetzungsAngaben/EinkLuF/Steuerpflichtiger/FolgeJahr, Betrieb/FestsetzungsAngaben/EinkGewBetr/' +
    'Steuerpflichtiger/FolgeJahr, Betrieb/FestsetzungsAngaben/EinkSelbst/Steuerpflichtiger/FolgeJahr, Betrieb/' +
    'FestsetzungsAngaben/EinkVermVerp/Steuerpflichtiger/FolgeJahr.';

const prepaymentFoundingYear = 'Bitte machen Sie Angaben in mindestens einem der folgenden Felder:' +
    ' Betrieb/FestsetzungsAngaben/EinkLuF/Steuerpflichtiger/GruendJahr, Betrieb/FestsetzungsAngaben/EinkGewBetr/' +
    'Steuerpflichtiger/GruendJahr, Betrieb/FestsetzungsAngaben/EinkSelbst/Steuerpflichtiger/GruendJahr, Betrieb/' +
    'FestsetzungsAngaben/EinkVermVerp/Steuerpflichtiger/GruendJahr.';

const invalidIncomeTaxAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht. Folgende Felder müssen hier mindestens' +
    ' ausgefüllt sein: Betrieb/LohnberechnungsStelle/Adrkette/StrAdr/Plz, Betrieb/LohnberechnungsStelle/Adrkette/StrAdr/Ort.';

const invalidEmployeesNumber = 'Die Werte in den Feldern Betrieb/LohnberechnungsStelle/' +
    'AnzahlBeschaeftigteFamilienangehoerige und Betrieb/LohnberechnungsStelle/AnzahlGeringfuegigBeschaeftigte können jeweils nicht höher' +
    ' sein als die Zahl der Arbeitnehmer insgesamt (Feld Betrieb/LohnberechnungsStelle/AnzahlBeschaeftigteArbeitnehmer).';

const invalidEntryDate = 'Das im Feld Betrieb/HrgAngaben/TagDerEintragung' +
    ' angegebene Datum darf nicht in der Zukunft liegen.';

const invalidRequestDate = 'Das im Feld Betrieb/HrgAngaben/TagDesAntrags' +
    ' angegebene Datum darf nicht in der Zukunft liegen.';

const emptyEntryData = 'Es wurde im Feld Betrieb/HrgAngaben/' +
    'HrgEintragVorhanden angegeben, dass ein Handelsregister-Eintrag vorliegt. Bitte machen Sie Angaben in den' +
    ' Feldern Betrieb/HrgAngaben/TagDerEintragung, Betrieb/HrgAngaben/HrgRegisterbezeichnung,' +
    ' Betrieb/HrgAngaben/HrgRegisternummer und Betrieb/HrgAngaben/HandelsregisterGericht.';

const emptyRequestData = 'Es wurde im Feld Betrieb/HrgAngaben/' +
    'HrgAntragGestellt angegeben, dass ein Antrag auf Eintragung im Handelsregister gestellt wurde. Bitte machen' +
    ' Sie Angaben in den Feldern Betrieb/HrgAngaben/TagDesAntrags und Betrieb/HrgAngaben/HandelsregisterGericht.';

const invalidIncorporationPreOwnerAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht. Folgende Felder müssen hier mindestens' +
    ' ausgefüllt sein: Betrieb/Gruendungsangaben/GruendungsForm/VorherigerInhaber/NatPers/Adrkette/StrAdr/Plz,' +
    ' Betrieb/Gruendungsangaben/GruendungsForm/VorherigerInhaber/NatPers/Adrkette/StrAdr/Ort.';

const emptyPreviousCompanyName = 'Bitte geben Sie Firmenname des vorherigen Unternehmens an.';

const emptyPreviousCompanyAddress = 'Bitte geben Sie Straße, Postleitzahl und Ort des vorherigen Unternehmens an.';

const invalidPreviousCompanyAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht. Folgende Felder' +
    ' müssen hier mindestens ausgefüllt sein: Betrieb/Gruendungsangaben/GruendungsForm/VorherigesUnternehmen/' +
    'NNatPers/Adrkette/StrAdr/Plz, /Betrieb/Gruendungsangaben/GruendungsForm/VorherigesUnternehmen/NNatPers/' +
    'Adrkette/StrAdr/Ort.';

const emptyPreOwnerName = 'Bitte geben Sie Name und Vorname des Vorinhabers an.';

const emptyPreOwnerAddress = 'Bitte geben Sie Straße, Postleitzahl und Ort des Vorinhabers an.';

const emptyIncorporationPreviousDataTyp = 'Bitte machen Sie Angaben zum vorherigen Unternehmen beziehungsweise zum Vorinhaber.';

const emptyIncorporationTyp = 'Bitte machen Sie Angaben in den Feldern Betrieb/Gruendungsangaben/' +
    'GruendungsForm/GruendungsArt und Betrieb/Gruendungsangaben/GruendungsForm/UebertrStichtag.';

const incompleteCompanyTelNumber = 'Das Feld Betrieb/Unternehmen/Komm/Tel/IntVorw' +
    ' darf nicht alleine angegeben werden. Bitte geben Sie auch eine nationale Vorwahl und eine Rufnummer an.';

const invalidCompanyTelNumber = 'Die Felder Betrieb/Unternehmen/Komm/Tel/NatVorw' +
    ' und Betrieb/Unternehmen/Komm/Tel/RufNr müssen gemeinsam angegeben werden.';

const emptyInternationalAddress = 'Es wurden Angaben zu einer Auslandsanschrift gemacht. Folgende Felder' +
    ' müssen hier mindestens ausgefüllt sein: Betrieb/Unternehmen/Adrkette/AuslAdr/AuslPlz,' +
    ' Betrieb/Unternehmen/Adrkette/AuslAdr/Ort, Betrieb/Unternehmen/Adrkette/AuslAdr/StaatId.';

const invalidLargeRecipientAddress = 'Es wurden Angaben zu einer Großempfängeranschrift gemacht. Folgende' +
    ' Felder müssen hier mindestens ausgefüllt sein: Betrieb/Unternehmen/Adrkette/GrossempfAdr/Plz,' +
    ' Betrieb/Unternehmen/Adrkette/GrossempfAdr/Ort.';

const invalidPOBox = 'Es wurden Angaben zu einer Postfachanschrift gemacht. Folgende Felder müssen hier' +
    ' mindestens ausgefüllt sein: Betrieb/Unternehmen/Adrkette/PostfAdr/Postfach, Betrieb/Unternehmen/Adrkette/PostfAdr/Plz,' +
    ' Betrieb/Unternehmen/Adrkette/PostfAdr/Ort.';

const invalidCompanyAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht. Folgende Felder müssen' +
    ' hier mindestens ausgefüllt sein: Betrieb/Unternehmen/Adrkette/StrAdr/Plz, Betrieb/Unternehmen/Adrkette/StrAdr/Ort.';

const noCompanyAddress = 'Bitte machen Sie Angaben zur Anschrift des Unternehmens.';

const incompleteDiffManagementTelNumber = 'Das Feld Betrieb/Geschaeftsleitung/Komm/Tel/IntVorw darf nicht' +
    ' alleine angegeben werden. Bitte geben Sie auch eine nationale Vorwahl und eine Rufnummer an.';

const invalidDiffManagementTelNumber = 'Die Felder Betrieb/Geschaeftsleitung/Komm/Tel/NatVorw und Betrieb/' +
    'Geschaeftsleitung/Komm/Tel/RufNr müssen gemeinsam angegeben werden.';

const invalidInternationalManagementAddress = 'Es wurden Angaben zu einer Auslandsanschrift gemacht. Folgende' +
    ' Felder müssen hier mindestens ausgefüllt sein: Betrieb/Geschaeftsleitung/Adrkette/AuslAdr/AuslPlz, Betrieb/' +
    'Geschaeftsleitung/Adrkette/AuslAdr/Ort, Betrieb/Geschaeftsleitung/Adrkette/AuslAdr/StaatId.';

const invalidManagementAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht. Folgende Felder' +
    ' müssen hier mindestens ausgefüllt sein: Betrieb/Geschaeftsleitung/Adrkette/StrAdr/Plz, Betrieb/' +
    'Geschaeftsleitung/Adrkette/StrAdr/Ort.';

const noMultipleManagementAddress = 'Beim Ort der Geschäftsleitung dürfen Inlands- und Auslandsadresse' +
    ' nicht gemeinsam angegeben werden.';

const invalidPreviousActivityDate = 'Das im Feld Betrieb/VorherigeTaetigkeitVon angegebene Datum darf nicht in der Zukunft liegen.';

const invalidPreviousActivityTilDate = 'Das im Feld Betrieb/VorherigeTaetigkeitBis angegebene Datum darf nicht in der Zukunft liegen.';

const emptyIncomeTaxInfo = 'Bitte machen Sie Angaben in den Feldern Betrieb/LohnberechnungsStelle/' +
    'BeginnLohnzahlungen und Betrieb/FestsetzungsAngaben/VoraussichtlicheLohnsteuer.';

const invalidIncomeTaxStartDate = 'Der Beginn der Lohnzahlungen kann frühestens ab dem Gründungsdatum erfolgen.';

const emptyCompanyTyp = 'Bitte machen Sie Angaben im Feld Betrieb/GewerbeArt.';

const incompleteTaxConsultingTelNumber = 'Das Feld Steuerberater/NNatPers/Komm/Tel/IntVorw darf nicht alleine' +
    ' angegeben werden. Bitte geben Sie auch eine nationale Vorwahl und eine Rufnummer an.';

const invalidTaxConsultingTelNumber = 'Die Felder Steuerberater/NNatPers/Komm/Tel/NatVorw und Steuerberater/' +
    'NNatPers/Komm/Tel/RufNr müssen gemeinsam angegeben werden.';

const incompleteTaxConsultingInternationalAddress = 'Es wurden Angaben zu einer Auslandsanschrift gemacht.' +
    ' Folgende Felder müssen hier mindestens ausgefüllt sein: Steuerberater/NNatPers/Adrkette/AuslAdr/AuslPlz,' +
    ' Steuerberater/NNatPers/Adrkette/AuslAdr/Ort, Steuerberater/NNatPers/Adrkette/AuslAdr/StaatId.';

const incompleteTaxConsultingAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht. Folgende Felder' +
    ' müssen hier mindestens ausgefüllt sein: Steuerberater/NNatPers/Adrkette/StrAdr/Plz, Steuerberater/NNatPers/' +
    'Adrkette/StrAdr/Ort.';

const emptyCompanyName = 'Bitte geben Sie beim Steuerberater den Firmennamen an.';

const noTaxConsultingAddress = 'Es wurden Angaben zum Steuerberater gemacht. Bitte geben Sie dazu eine' +
    ' Inlands- oder Auslandsanschrift an.';

const incompleteTaxConsultingNaturalTelNumber = 'Das Feld Steuerberater/NatPers/Komm/Tel/IntVorw darf' +
    ' nicht alleine angegeben werden. Bitte geben Sie auch eine nationale Vorwahl und eine Rufnummer an.';

const invalidTaxConsultingNaturalTelNumber = 'Die Felder Steuerberater/NatPers/Komm/Tel/NatVorw und' +
    ' Steuerberater/NatPers/Komm/Tel/RufNr müssen gemeinsam angegeben werden.';

const incompleteTaxConsultingNaturalInternationalAddress = 'Es wurden Angaben zu einer Auslandsanschrift gemacht.' +
    ' Folgende Felder müssen hier mindestens ausgefüllt sein: Steuerberater/NatPers/Adrkette/AuslAdr/AuslPlz,' +
    ' Steuerberater/NatPers/Adrkette/AuslAdr/Ort, Steuerberater/NatPers/Adrkette/AuslAdr/StaatId.';

const incompleteTaxConsultingNaturalAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht. Folgende Felder' +
    ' müssen hier mindestens ausgefüllt sein: Steuerberater/NatPers/Adrkette/StrAdr/Plz, Steuerberater/NatPers/' +
    'Adrkette/StrAdr/Ort.';

const emptyConsulterName = 'Bitte geben Sie beim Steuerberater Vorname und Name an.';

const incompleteAuthorizedRecipientTelNumber = 'Das Feld Empfangsbev/NNatPers/Komm/Tel/IntVorw darf nicht' +
    ' alleine angegeben werden. Bitte geben Sie auch eine nationale Vorwahl und eine Rufnummer an.';

const invalidAuthorizedRecipientTelNumber = 'Die Felder Empfangsbev/NNatPers/Komm/Tel/NatVorw und Empfangsbev/' +
    'NNatPers/Komm/Tel/RufNr müssen gemeinsam angegeben werden.';

const incompleteAuthorizedRecipientInternationalAddress = 'Es wurden Angaben zu einer Auslandsanschrift' +
    ' gemacht. Folgende Felder müssen hier mindestens ausgefüllt sein: Empfangsbev/NNatPers/Adrkette/AuslAdr/' +
    'AuslPlz, Empfangsbev/NNatPers/Adrkette/AuslAdr/Ort, Empfangsbev/NNatPers/Adrkette/AuslAdr/StaatId.';

const incompleteAuthorizedRecipientAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht. Folgende' +
    ' Felder müssen hier mindestens ausgefüllt sein: Empfangsbev/' +
    'NNatPers/Adrkette/StrAdr/Plz, Empfangsbev/NNatPers/' +
    'Adrkette/StrAdr/Ort.';

const emptyAuthorizedRecipientCompanyName = 'Bitte geben Sie beim Empfangsbevollmächtigten den Firmennamen' +
    ' an (Empfangsbevollmächtigter).';

const noAuthorizedRecipientAddress = 'Es wurden Angaben zum Empfangsbevollmächtigten gemacht. Bitte geben' +
    ' Sie dazu eine Inlands- oder Auslandsanschrift an.';

const incompleteNaturalAuthorizedRecipientTelNumber = 'Das Feld ' +
    'Empfangsbev/NatPers/Komm/Tel/IntVorw darf nicht alleine angegeben werden. Bitte geben Sie auch eine' +
    ' nationale Vorwahl und eine Rufnummer an.';

const invalidNaturalAuthorizedRecipientTelNumber = 'Die Felder ' +
    'Empfangsbev/NatPers/Komm/Tel/NatVorw und Empfangsbev/' +
    'NatPers/Komm/Tel/RufNr müssen gemeinsam angegeben werden.';

const incompleteNaturalAuthorizedRecipientInternationalAddress = 'Es wurden Angaben zu einer Auslandsanschrift' +
    ' gemacht. Folgende Felder müssen hier mindestens ausgefüllt sein: Empfangsbev/NatPers/Adrkette/AuslAdr/' +
    'AuslPlz, Empfangsbev/NatPers/Adrkette/AuslAdr/Ort, Empfangsbev/NatPers/Adrkette/AuslAdr/StaatId.';

const incompleteNaturalAuthorizedRecipientAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht.' +
    ' Folgende Felder müssen hier mindestens ausgefüllt sein: ' +
    'Empfangsbev/NatPers/Adrkette/StrAdr/Plz, Empfangsbev/NatPers/' +
    'Adrkette/StrAdr/Ort.';

const emptyAuthorizedRecipientName = 'Bitte geben Sie beim Empfangsbevollmächtigten Vorname und Name' +
    ' an (Empfangsbevollmächtigter).';

const incompletePartnershipInternationalAddress = 'Es wurden Angaben zu einer Auslandsanschrift gemacht.' +
    ' Folgende Felder müssen hier mindestens ausgefüllt sein: ' +
    'Ehegatte/NatPers/Adrkette/AuslAdr/AuslPlz, Ehegatte/NatPers/' +
    'Adrkette/AuslAdr/Ort, Ehegatte/NatPers/Adrkette/AuslAdr/' +
    'StaatId.';

const incompletePartnershipPOBox = 'Es wurden Angaben zu einer Postfachanschrift gemacht. Folgende Felder' +
    ' müssen hier mindestens ausgefüllt sein: Ehegatte/NatPers/' +
    'Adrkette/PostfAdr/Postfach, Ehegatte/NatPers/Adrkette/' +
    'PostfAdr/Plz, Ehegatte/NatPers/Adrkette/PostfAdr/Ort.';

const incompletePartnershipAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht.' +
    ' Folgende Felder müssen hier mindestens ausgefüllt sein: ' +
    'Ehegatte/NatPers/Adrkette/StrAdr/Plz, Ehegatte/NatPers/' +
    'Adrkette/StrAdr/Ort.';

const invalidPartnershipBirthday = 'Das im Feld Ehegatte/' +
    'NatPers/GebDat angegebene Datum darf nicht in der Zukunft liegen.';

const emptyPartnershipData = 'Es wurde eine Eintragung im Feld Inhaber/NatPers/Personenstand/Merker gemacht.' +
    ' Bitte machen Sie auch Angaben in den Feldern Ehegatte/NatPers/Vorname,' +
    ' Ehegatte/NatPers/GebDat und Ehegatte/NatPers/Religion.';

const incompletePartnershipData = 'Es wurden Daten zum Ehegatten eingetragen. Bitte machen Sie Angaben in den' +
    ' Feldern Inhaber/NatPers/Personenstand/Merker und Inhaber/NatPers/Personenstand/Von.';

const emptyPartnershipDate = 'Bitte machen Sie Angaben im Feld Inhaber/NatPers/Personenstand/Von.';

const incompletBankDetails = 'Die IBAN und die Rolle des Kontoinhabers müssen gemeinsam angegeben werden.';

const invalidGermanIBAN = 'Es wurde eine inländische IBAN eingegeben, die nicht mit "DE" beginnt.';

const invalidInternationalIBAN = 'Es wurde eine ausländische IBAN eingegeben, die mit "DE" beginnt.';

const noMixedBankDetails = 'Eine inländische und ausländische IBAN dürfen nicht gleichzeitig eingegeben werden.';

const invalidBic = 'Die Eingabe eines BIC ist nur im Zusammenhang mit einer ausländischen IBAN zulässig.';

const emptyDiffAccountHolder = 'Es wurde angegeben, dass ein abweichender Kontoinhaber vorliegt. Bitte machen' +
    ' sie Angaben im Feld Inhaber/NatPers/BankKonto/AbwKontoinhaber.';

const emptyBankDetails = 'Es wurden Angaben zu einer Bankverbindung gemacht. Es wurde jedoch keine IBAN' +
    ' angegeben. Bei Angabe einer IBAN aus der Schweiz, San Marino oder Monaco ist zudem die Angabe des Feldes' +
    ' Inhaber/NatPers/BankKonto/Bicerforderlich.';

const invalidSalesTaxIdentifier = 'Die angegebene Umsatzsteuer-Identifikationsnummer beginnt nicht mit dem' +
    ' Länderkennzeichen Deutschlands. Bitte tragen Sie eine deutsche Umsatzsteuer-Identifikationsnummer ein.';

const invalidSalesTaxIdentifierDate = 'Das im Feld Inhaber/' +
    'NatPers/UStIdNr/VergDat angegebene Datum darf nicht in der Zukunft liegen.';

const incompletePersonalTelNumber = 'Das Feld ' +
    'Inhaber/NatPers/Komm/Tel/IntVorw darf nicht alleine angegeben werden. Bitte geben Sie auch eine' +
    ' nationale Vorwahl und eine Rufnummer an.';

const invalidPersonalTelNumber = 'Die Felder ' +
    'Inhaber/NatPers/Komm/Tel/NatVorw und Inhaber/' +
    'NatPers/Komm/Tel/RufNr müssen gemeinsam angegeben werden.';

const incompletePersonalInternationalAddress = 'Es wurden Angaben zu einer Auslandsanschrift gemacht.' +
    ' Folgende Felder müssen hier mindestens ausgefüllt sein: ' +
    'Inhaber/NatPers/Adrkette/AuslAdr/AuslPlz, Inhaber/NatPers/' +
    'Adrkette/AuslAdr/Ort, Inhaber/NatPers/Adrkette/AuslAdr/' +
    'StaatId.';

const incompletePersonalAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht.' +
    ' Folgende Felder müssen hier mindestens ausgefüllt sein: ' +
    'Inhaber/NatPers/Adrkette/StrAdr/Plz, Inhaber/NatPers/' +
    'Adrkette/StrAdr/Ort.';

const incompletePersonalPOBox = 'Es wurden Angaben zu einer Postfachanschrift gemacht. Folgende Felder' +
    ' müssen hier mindestens ausgefüllt sein: Inhaber/NatPers/' +
    'Adrkette/PostfAdr/Postfach, Inhaber/NatPers/Adrkette/' +
    'PostfAdr/Plz, Inhaber/NatPers/Adrkette/PostfAdr/Ort.';

const emptyPersonalAddress = 'Es wurden Angaben zum Steuerpflichtigen gemacht. Bitte geben Sie dazu eine' +
    ' Inlands- oder Auslandsanschrift an.';

const invalidPersonalBirthday = 'Das im Feld Inhaber/NatPers/' +
    'GebDat angegebene Datum darf nicht in der Zukunft liegen.';

const emptyPersonalData = 'Bitte machen Sie Angaben in den Feldern Inhaber/NatPers/Name,' +
    ' Inhaber/NatPers/Vorname, Inhaber/NatPers/GebDat und Inhaber/NatPers/Religion.';

const emptyOperatingSiteAddress = 'Es wurden der Name der Betriebstätte und / oder Angaben zu Kommunikationsverbindungen angegeben.' +
    ' Bitte machen Sie auch Angaben zur Adresse der Betriebstätte.';

const incorrectInternationalIBAN = 'Feld Inhaber/' +
    'NatPers/BankKonto/IbanAusland: Ungültige IBAN: Der angegebene Ländercode ist ungültig oder' +
    ' wird aktuell im ELSTER-Verfahren nicht unterstützt.';

const incorrectInternationalBIC = 'Feld Inhaber/' +
    'NatPers/BankKonto/Bic: Ungültiger BIC: Der formale Aufbau des angegebenen BIC ist ungültig.';

const incorrectFormInernationalIBAN = 'Feld Inhaber/' +
    'NatPers/BankKonto/IbanAusland: Ungültige IBAN: Die angegebene IBAN entspricht nicht dem für das' +
    ' angegebene Land definierten formalen Aufbau der IBAN.';

const invalidCurrentOperationalUstId = 'Feld Betrieb/' +
    'VorherigeTaetigkeitUStId: Ungültige UStIDNr: Die angegebene Umsatzsteuer-Identifikationsnummer' +
    ' ist ungültig.';

const incorrectCurrentOperationalRatioUstId = 'Feld Betrieb/' +
    'VorherigeTaetigkeitUStId: Ungültige UStIDNr: Der formale Aufbau der angegebenen UStIDNr ist' +
    ' ungültig. Die UStIDNr muss mit zwei Großbuchstaben beginnen, dem Länderkürzel. Die folgenden' +
    ' Zeichen können Kleinbuchstaben, Großbuchstaben, Ziffern oder die Sonderzeichen \'+\' und \'*\',' +
    ' jedoch keine anderen Sonderzeichen, keine Leerzeichen und keine Umlaute sein.';

const invalidGermanCurrentOperationalRatioUstId = 'Feld ' +
    'Betrieb/VorherigeTaetigkeitUStId: Ungültige UStIDNr: Der formale Aufbau der angegebenen UStIDNr ist' +
    ' ungültig. In Deutschland muss die UStIDNr nach dem zweistelligen Länderkürzel genau 9 Zeichen' +
    ' enthalten.';

const invalidGermanSalesTaxUstId = 'Feld Inhaber/NatPers/' +
    'UStIdNr/UstId: Ungültige UStIDNr: Der formale Aufbau der angegebenen UStIDNr ist ungültig. In' +
    ' Deutschland muss die UStIDNr nach dem zweistelligen Länderkürzel genau 9 Zeichen enthalten.';

const invalidGermanFormOfIncorporationUstId = 'Feld Betrieb/' +
    'Gruendungsangaben/GruendungsForm/VorherigesUnternehmen/NNatPers/Ordnungskriterium/UstId: Ungültige' +
    ' UStIDNr: Der formale Aufbau der angegebenen UStIDNr ist ungültig. In Deutschland muss die UStIDNr' +
    ' nach dem zweistelligen Länderkürzel genau 9 Zeichen enthalten.';

const invalidGermanOrganizationsUstId = 'Feld Umsatzsteuer/' +
    'Organschaft/NNatPers/Ordnungskriterium/UstId: Ungültige UStIDNr: Der formale Aufbau der angegebenen' +
    ' UStIDNr ist ungültig. In Deutschland muss die UStIDNr nach dem zweistelligen Länderkürzel genau 9' +
    ' Zeichen enthalten.';

const invalidFormOfIncorporationUstId = 'Feld Betrieb/' +
    'Gruendungsangaben/GruendungsForm/VorherigesUnternehmen/NNatPers/Ordnungskriterium/UstId: Ungültige' +
    ' UStIDNr: Die angegebene Umsatzsteuer-Identifikationsnummer ist ungültig.';

const invalidSalesTaxUstId = 'Feld Inhaber/NatPers/' +
    'UStIdNr/UstId: Ungültige UStIDNr: Die angegebene Umsatzsteuer-Identifikationsnummer ist ungültig.';

const invalidOrganizationsUstId = 'Feld Umsatzsteuer/' +
    'Organschaft/NNatPers/Ordnungskriterium/UstId: Ungültige' +
    ' UStIDNr: Die angegebene Umsatzsteuer-Identifikationsnummer ist ungültig.';

const incorrectOrganizationsUstId = 'Feld ' +
    'Umsatzsteuer/Organschaft/NNatPers/Ordnungskriterium/UstId: Ungültige UStIDNr: Der formale Aufbau' +
    ' der angegebenen UStIDNr ist ungültig. Die UStIDNr muss mit zwei Großbuchstaben beginnen, dem' +
    ' Länderkürzel. Die folgenden Zeichen können Kleinbuchstaben, Großbuchstaben, Ziffern oder die' +
    ' Sonderzeichen \'+\' und \'*\', jedoch keine anderen Sonderzeichen, keine Leerzeichen und keine' +
    ' Umlaute sein.';

const incorrectSalesTaxUstId = 'Feld Inhaber/' +
    'NatPers/UStIdNr/UstId: Ungültige UStIDNr: Der formale Aufbau der angegebenen UStIDNr ist ungültig.' +
    ' Die UStIDNr muss mit zwei Großbuchstaben beginnen, dem Länderkürzel. Die folgenden Zeichen' +
    ' können Kleinbuchstaben, Großbuchstaben, Ziffern oder die Sonderzeichen \'+\' und \'*\', jedoch' +
    ' keine anderen Sonderzeichen, keine Leerzeichen und keine Umlaute sein.';

const incorrectFormOfIncorporationUstId = 'Feld ' +
    'Betrieb/Gruendungsangaben/GruendungsForm/VorherigesUnternehmen/NNatPers/Ordnungskriterium/UstId:' +
    ' Ungültige UStIDNr: Der formale Aufbau der angegebenen UStIDNr ist ungültig. Die UStIDNr muss' +
    ' mit zwei Großbuchstaben beginnen, dem Länderkürzel. Die folgenden Zeichen können Kleinbuchstaben,' +
    ' Großbuchstaben, Ziffern oder die Sonderzeichen \'+\' und \'*\', jedoch keine anderen' +
    ' Sonderzeichen, keine Leerzeichen und keine Umlaute sein.';

const emptyOrganizationsParticipation = 'Bitte geben Sie die Höhe der Beteiligung in Bruchteilen' +
    ' mit Zähler und Nenner an.';

const incompleteOrganizationsPOBox = 'Es wurden Angaben zu einer Postfachanschrift gemacht.' +
    ' Folgende Felder müssen hier mindestens ausgefüllt sein: Umsatzsteuer/Organschaft/NNatPers/Adrkette/' +
    'PostfAdr/Postfach, Umsatzsteuer/Organschaft/NNatPers/Adrkette/PostfAdr/Plz,' +
    ' Umsatzsteuer/Organschaft/NNatPers/Adrkette/PostfAdr/Ort.';

const counterGreaterThanDenominator = 'Der im Feld ' +
    'Umsatzsteuer/Organschaft/Beteiligung/Bruchteil/Zaehler angegebene Wert darf nicht den im Feld' +
    ' Umsatzsteuer/Organschaft/Beteiligung/Bruchteil/' +
    'Nenner angegebenen Wert übersteigen.';

const incompleteOrganizationsAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht.' +
    ' Folgende Felder müssen hier mindestens ausgefüllt sein: Umsatzsteuer/Organschaft/NNatPers/' +
    'Adrkette/StrAdr/Plz, Umsatzsteuer/Organschaft/NNatPers/Adrkette/StrAdr/Ort.';

const emptyOrganizationsCompanyName = 'Es wurden Angaben zur organschaftlichen Verbindung' +
    ' gemacht. Bitte machen Sie Angaben im Feld ' +
    'Umsatzsteuer/Organschaft/NNatPers/Firmenname.';

const invalidOperatingSiteTelNumber = 'Die Felder Betrieb/' +
    'BetriebsstaettenListe/Betriebsstaette/Komm/Tel/NatVorw und ' +
    'Betrieb/BetriebsstaettenListe/Betriebsstaette/Komm/Tel/RufNr müssen gemeinsam angegeben werden.';

const incompleteOperatingSiteTelNumber = 'Das Feld Betrieb/' +
    'BetriebsstaettenListe/Betriebsstaette/Komm/Tel/IntVorw darf nicht alleine angegeben werden. Bitte geben' +
    ' Sie auch eine nationale Vorwahl und eine Rufnummer an.';

const emptyInternationalOperatingSiteAddress = 'Es wurden Angaben zu einer Auslandsanschrift gemacht.' +
    ' Folgende Felder müssen hier mindestens ausgefüllt sein: ' +
    'Betrieb/BetriebsstaettenListe/Betriebsstaette/Adrkette/AuslAdr/AuslPlz, Betrieb/BetriebsstaettenListe/' +
    'Betriebsstaette/Adrkette/AuslAdr/Ort, Betrieb/BetriebsstaettenListe/Betriebsstaette/Adrkette/AuslAdr/StaatId.';

const incorrectOperatingSiteAddress = 'Es wurden Angaben zu einer Inlandsanschrift gemacht. Folgende Felder' +
    ' müssen hier mindestens ausgefüllt sein: Betrieb/BetriebsstaettenListe/Betriebsstaette/Adrkette/StrAdr/Plz,' +
    ' Betrieb/BetriebsstaettenListe/Betriebsstaette/Adrkette/StrAdr/Ort.';

const noMultipleOperatingSiteAddress =
    'Bei einer Betriebstätte dürfen eine Inlandsadresse und eine Auslandsadresse nicht gemeinsam angegeben werden.';

export const noEmailInAnhaengeProvided = 'Das Feld Anhaenge/Rueckmeldung/EmailRueckmeldung ist ungültig. Geben Sie ein gültige' +
              ' E-Mail-Adresse ein, um digitale Dokumente übermitteln zu können.';

export const ericErrorTypes: Map<string, EricErrorConfig> = new Map<string, EricErrorConfig>([
  [noEmailInAnhaengeProvided, {
    route: attachmentsRoute,
    ids: ['#email']
  } as EricErrorConfig],
    [smallBusinessNotSet, {
        route: salesTaxRoute,
        ids: ['#kleinunternehmerRegelung']
    } as EricErrorConfig],
    [smallBusinessNotValid, {
        route: salesTaxRoute,
        ids: ['#kleinunternehmerRegelung']
    } as EricErrorConfig],
    [sollIstTax, {
        route: salesTaxRoute,
        ids: ['#sollIstVersteuerung']
    } as EricErrorConfig],
    [invalidSollIstSmallBusiness, {
        route: salesTaxRoute,
        ids: ['#kleinunternehmerRegelung', '#sollIstVersteuerung']
    } as EricErrorConfig],
    [emptyFoundingYearSales, {
        route: salesTaxRoute,
        ids: ['#summeUmsaetzeJahrBetriebseroeffnung']
    } as EricErrorConfig],
    [emptyNextYearSales, {
        route: salesTaxRoute,
        ids: ['#summeUmsaetzeFolgejahr']
    } as EricErrorConfig],
    [salesTaxFreeType, {
        route: salesTaxRoute,
        ids: ['#steuerfreieUmsaetzeArt']
    } as EricErrorConfig],
    [salesTaxReducedType, {
        route: salesTaxRoute,
        ids: ['#steuerermaessigteUmsaetzeArt']
    } as EricErrorConfig],
    [invalidTaxLiability, {
        route: salesTaxRoute,
        ids: ['#nachweisSteuerschuldnerschaftBauleistungen',
            '#nachweisSteuerschuldnerschaftGebaeudereinigungsleistungen']
    } as EricErrorConfig],
    [averageTaxation, {
        route: salesTaxRoute,
        ids: ['#durchschnittsbesteuerteUmsaetzeArt']
    } as EricErrorConfig],
    [emptyOldAddress, {
        route: {
            path: 'bisherige-persoenliche-verhaeltnisse-angaben',
            queryParams: {}
        },
        ids: ['#zugezogenAm',
            '#inlandsadresseHausnummer',
            addressIds
        ]
    } as EricErrorConfig],
    [profitDeterminationType, {
        route: profitDeterminationRoute,
        ids: ['#gewinnermittlungsart']
    } as EricErrorConfig],
    [emptyDeviatedYear, {
        route: profitDeterminationRoute,
        ids: ['#beginnAbweichendesWirtschaftsjahr']
    } as EricErrorConfig],
    [invalidDeviatedYear, {
        route: profitDeterminationRoute,
        ids: ['#beginnAbweichendesWirtschaftsjahr']
    } as EricErrorConfig],
    [prepaymentNextYear, {
        route: prepaymentRoute,
        ids: ['#steuerpflichtigerFolgejahrLandForstwirtschaft',
            '#steuerpflichtigerFolgejahrGewerbebetrieb',
            '#steuerpflichtigerFolgejahrSelbstaendigerArbeit',
            '#steuerpflichtigerFolgejahrVermietungVerpachtung']
    } as EricErrorConfig],
    [prepaymentFoundingYear, {
        route: prepaymentRoute,
        ids: ['#steuerpflichtigerJahrBetriebseroeffnungLandForstwirtschaft',
            '#steuerpflichtigerJahrBetriebseroeffnungGewerbebetrieb',
            '#steuerpflichtigerJahrBetriebseroeffnungSelbstaendigerArbeit',
            '#steuerpflichtigerJahrBetriebseroeffnungVermietungVerpachtung']
    } as EricErrorConfig],
    [invalidIncomeTaxAddress, {
        route: incomeTaxRoute,
        ids: addressIds.slice(-2)
    } as EricErrorConfig],
    [invalidEmployeesNumber, {
        route: incomeTaxRoute,
        ids: ['#familienangehoerige', '#geringfuegigBeschaeftigte', '#arbeitnehmer']
    } as EricErrorConfig],
    [invalidEntryDate, {
        route: commercialRegisterEntryRoute,
        ids: ['#eingetragenAm']
    } as EricErrorConfig],
    [invalidRequestDate, {
        route: commercialRegisterEntryRoute,
        ids: ['#gestelltAm']
    } as EricErrorConfig],
    [emptyEntryData, {
        route: commercialRegisterEntryRoute,
        ids: ['#eingetragenAm', '#handelsregisterBezeichnung', '#handelsregisterNummer', '#ortRegistergericht']
    } as EricErrorConfig],
    [emptyRequestData, {
        route: commercialRegisterEntryRoute,
        ids: ['#gestelltAm', '#ortRegistergericht']
    } as EricErrorConfig],
    [invalidIncorporationPreOwnerAddress, {
        route: formOfIncorporationRoute,
        ids: addressIds.slice(-2)
    } as EricErrorConfig],
    [emptyPreviousCompanyName, {
        route: formOfIncorporationRoute,
        ids: ['#firmenname']
    } as EricErrorConfig],
    [emptyPreviousCompanyAddress, {
        route: formOfIncorporationRoute,
        ids: addressIds
    } as EricErrorConfig],
    [invalidPreviousCompanyAddress, {
        route: formOfIncorporationRoute,
        ids: addressIds.slice(-2)
    } as EricErrorConfig],
    [emptyPreOwnerName, {
        route: formOfIncorporationRoute,
        ids: ['#nachname', '#vorname']
    } as EricErrorConfig],
    [emptyPreOwnerAddress, {
        route: formOfIncorporationRoute,
        ids: addressIds
    } as EricErrorConfig],
    [emptyIncorporationPreviousDataTyp, {
        route: formOfIncorporationRoute,
        ids: ['#vorherigesUnternehmenTyp']
    } as EricErrorConfig],
    [emptyIncorporationTyp, {
        route: formOfIncorporationRoute,
        ids: ['#gruendungsart', '#gruendungsdatum']
    } as EricErrorConfig],
    [incompleteCompanyTelNumber, {
        route: companyRoute,
        ids: telNumberIds
    } as EricErrorConfig],
    [invalidCompanyTelNumber, {
        route: companyRoute,
        ids: telNumberIds.slice(-4)
    } as EricErrorConfig],
    [emptyInternationalAddress, {
        route: companyRoute,
        ids: internationalAddressIds
    } as EricErrorConfig],
    [invalidLargeRecipientAddress, {
        route: companyRoute,
        ids: ['#grossempfaengeradressePostleitzahl',
            '#grossempfaengeradresseOrt']
    } as EricErrorConfig],
    [invalidPOBox, {
        route: companyRoute,
        ids: poBoxIds
    } as EricErrorConfig],
    [invalidCompanyAddress, {
        route: companyRoute,
        ids: addressIds.slice(-2)
    } as EricErrorConfig],
    [noCompanyAddress, {
        route: companyRoute,
        ids: addressIds
    } as EricErrorConfig],
    [incompleteDiffManagementTelNumber, {
        route: diffManagementRoute,
        ids: telNumberIds
    } as EricErrorConfig],
    [invalidDiffManagementTelNumber, {
        route: diffManagementRoute,
        ids: telNumberIds.slice(-4)
    } as EricErrorConfig],
    [invalidInternationalManagementAddress, {
        route: diffManagementRoute,
        ids: internationalAddressIds
    } as EricErrorConfig],
    [invalidManagementAddress, {
        route: diffManagementRoute,
        ids: addressIds.slice(-2)
    } as EricErrorConfig],
    [noMultipleManagementAddress, {
        route: diffManagementRoute,
        ids: ['#inlandsadresseStrasse',
            '#auslandsadresseStrasse']
    } as EricErrorConfig],
    [invalidPreviousActivityDate, {
        route: currentOperationalRatioRoute,
        ids: ['#dauerVon']
    } as EricErrorConfig],
    [invalidPreviousActivityTilDate, {
        route: currentOperationalRatioRoute,
        ids: ['#dauerBis']
    } as EricErrorConfig],
    [emptyIncomeTaxInfo, {
        route: incomeTaxRoute,
        ids: ['#beginnLohnzahlungen', '#voraussichtlicheLohnsteuer']
    } as EricErrorConfig],
    [invalidIncomeTaxStartDate, {
        route: formOfIncorporationRoute,
        ids: ['#gruendungsdatum']
    } as EricErrorConfig],
    [emptyCompanyTyp, {
        route: companyRoute,
        ids: ['#artTaetigkeit']
    } as EricErrorConfig],
    [incompleteTaxConsultingTelNumber, {
        route: taxConsultingRoute,
        ids: telNumberIds
    } as EricErrorConfig],
    [invalidTaxConsultingTelNumber, {
        route: taxConsultingRoute,
        ids: telNumberIds.slice(-4)
    } as EricErrorConfig],
    [incompleteTaxConsultingInternationalAddress, {
        route: taxConsultingRoute,
        ids: internationalAddressIds
    } as EricErrorConfig],
    [incompleteTaxConsultingAddress, {
        route: taxConsultingRoute,
        ids: addressIds.slice(-2)
    } as EricErrorConfig],
    [emptyCompanyName, {
        route: taxConsultingRoute,
        ids: ['#firmenname']
    } as EricErrorConfig],
    [noTaxConsultingAddress, {
        route: taxConsultingRoute,
        ids: ['#inlandsadresseStrasse',
            '#auslandsadresseStrasse']
    } as EricErrorConfig],
    [incompleteTaxConsultingNaturalTelNumber, {
        route: taxConsultingRoute,
        ids: telNumberIds
    } as EricErrorConfig],
    [invalidTaxConsultingNaturalTelNumber, {
        route: taxConsultingRoute,
        ids: telNumberIds.slice(-4)
    } as EricErrorConfig],
    [incompleteTaxConsultingNaturalInternationalAddress, {
        route: taxConsultingRoute,
        ids: internationalAddressIds
    } as EricErrorConfig],
    [incompleteTaxConsultingNaturalAddress, {
        route: taxConsultingRoute,
        ids: addressIds.slice(-2)
    } as EricErrorConfig],
    [emptyConsulterName, {
        route: taxConsultingRoute,
        ids: ['#vorname', '#nachname']
    } as EricErrorConfig],
    [incompleteAuthorizedRecipientTelNumber, {
        route: authorizedRecipientRoute,
        ids: telNumberIds
    } as EricErrorConfig],
    [invalidAuthorizedRecipientTelNumber, {
        route: authorizedRecipientRoute,
        ids: telNumberIds.slice(-4)
    } as EricErrorConfig],
    [incompleteAuthorizedRecipientInternationalAddress, {
        route: authorizedRecipientRoute,
        ids: internationalAddressIds
    } as EricErrorConfig],
    [incompleteAuthorizedRecipientAddress, {
        route: authorizedRecipientRoute,
        ids: addressIds
    } as EricErrorConfig],
    [emptyAuthorizedRecipientCompanyName, {
        route: authorizedRecipientRoute,
        ids: ['#firmenname']
    } as EricErrorConfig],
    [noAuthorizedRecipientAddress, {
        route: authorizedRecipientRoute,
        ids: ['#inlandsadresseStrasse',
            '#auslandsadresseStrasse']
    } as EricErrorConfig],
    [incompleteNaturalAuthorizedRecipientTelNumber, {
        route: authorizedRecipientRoute,
        ids: telNumberIds
    } as EricErrorConfig],
    [invalidNaturalAuthorizedRecipientTelNumber, {
        route: authorizedRecipientRoute,
        ids: telNumberIds.slice(-4)
    } as EricErrorConfig],
    [incompleteNaturalAuthorizedRecipientInternationalAddress, {
        route: authorizedRecipientRoute,
        ids: internationalAddressIds
    } as EricErrorConfig],
    [incompleteNaturalAuthorizedRecipientAddress, {
        route: authorizedRecipientRoute,
        ids: addressIds.slice(-2)
    } as EricErrorConfig],
    [emptyAuthorizedRecipientName, {
        route: authorizedRecipientRoute,
        ids: ['#vorname', '#nachname']
    } as EricErrorConfig],
    [incompletePartnershipInternationalAddress, {
        route: partnershipRoute,
        ids: internationalAddressIds
    } as EricErrorConfig],
    [incompletePartnershipPOBox, {
        route: partnershipRoute,
        ids: poBoxIds
    } as EricErrorConfig],
    [incompletePartnershipAddress, {
        route: partnershipRoute,
        ids: addressIds.slice(-2)
    } as EricErrorConfig],
    [invalidPartnershipBirthday, {
        route: partnershipRoute,
        ids: ['#geburtsdatum']
    } as EricErrorConfig],
    [emptyPartnershipData, {
        route: partnershipRoute,
        ids: personIds
    } as EricErrorConfig],
    [emptyPartnershipDate, {
        route: partnershipRoute,
        ids: ['#gueltigSeit']
    } as EricErrorConfig],
    [incompletePartnershipData, {
        route: partnershipRoute,
        ids: ['#personenstand', '#gueltigSeit']
    } as EricErrorConfig],
    [incompletBankDetails, {
        route: bankDetailsRoute,
        ids: ['#kontoinhaber0',
            '#kontoinhaber1',
            bankIds]
    } as EricErrorConfig],
    [invalidGermanIBAN, {
        route: bankDetailsRoute,
        ids: bankIds
    } as EricErrorConfig],
    [invalidInternationalIBAN, {
        route: bankDetailsRoute,
        ids: bankIds
    } as EricErrorConfig],
    [noMixedBankDetails, {
        route: bankDetailsRoute,
        ids: bankIds
    } as EricErrorConfig],
    [invalidBic, {
        route: bankDetailsRoute,
        ids: ['#bic0', '#bic1', bankIds]
    } as EricErrorConfig],
    [emptyDiffAccountHolder, {
        route: bankDetailsRoute,
        ids: ['#abweichenderKontoinhaber0', '#abweichenderKontoinhaber1']
    } as EricErrorConfig],
    [emptyBankDetails, {
        route: bankDetailsRoute,
        ids: ['#bic0', '#bic1', bankIds]
    } as EricErrorConfig],
    [invalidSalesTaxIdentifier, {
        route: salesTaxRoute,
        ids: ['#ustIdentifikationsnummer']
    } as EricErrorConfig],
    [invalidSalesTaxIdentifierDate, {
        route: salesTaxRoute,
        ids: ['#ustIdentifikationsnummerVergabedatum']
    } as EricErrorConfig],
    [incompletePersonalTelNumber, {
        route: personalRoute,
        ids: telNumberIds
    } as EricErrorConfig],
    [invalidPersonalTelNumber, {
        route: personalRoute,
        ids: telNumberIds.slice(-4)
    } as EricErrorConfig],
    [incompletePersonalInternationalAddress, {
        route: personalRoute,
        ids: internationalAddressIds
    } as EricErrorConfig],
    [incompletePersonalAddress, {
        route: personalRoute,
        ids: addressIds.slice(-2)
    } as EricErrorConfig],
    [incompletePersonalPOBox, {
        route: personalRoute,
        ids: poBoxIds
    } as EricErrorConfig],
    [emptyPersonalAddress, {
        route: personalRoute,
        ids: ['#inlandsadresseStrasse',
            '#auslandsadresseStrasse']
    } as EricErrorConfig],
    [invalidPersonalBirthday, {
        route: personalRoute,
        ids: ['#geburtsdatum']
    } as EricErrorConfig],
    [emptyPersonalData, {
        route: personalRoute,
        ids: personIds
    } as EricErrorConfig],
    [incorrectInternationalIBAN, {
        route: bankDetailsRoute,
        ids: bankIds
    } as EricErrorConfig],
    [incorrectInternationalBIC, {
        route: bankDetailsRoute,
        ids: ['#bic0', '#bic1']
    } as EricErrorConfig],
    [incorrectFormInernationalIBAN, {
        route: bankDetailsRoute,
        ids: bankIds
    } as EricErrorConfig],
    [invalidCurrentOperationalUstId, {
        route: currentOperationalRatioRoute,
        ids: ['#ustIdentifikationsnummer']
    } as EricErrorConfig],
    [incorrectCurrentOperationalRatioUstId, {
        route: currentOperationalRatioRoute,
        ids: ['#ustIdentifikationsnummer']
    } as EricErrorConfig],
    [invalidGermanCurrentOperationalRatioUstId, {
        route: currentOperationalRatioRoute,
        ids: ['#ustIdentifikationsnummer']
    } as EricErrorConfig],
    [invalidGermanSalesTaxUstId, {
        route: salesTaxRoute,
        ids: ['#ustIdentifikationsnummer']
    } as EricErrorConfig],
    [invalidGermanFormOfIncorporationUstId, {
        route: formOfIncorporationRoute,
        ids: ['#vorherigesUnternehmenUstIdentifikationsnummer']
    } as EricErrorConfig],
    [invalidSalesTaxUstId, {
        route: salesTaxRoute,
        ids: ['#ustIdentifikationsnummer']
    } as EricErrorConfig],
    [invalidFormOfIncorporationUstId, {
        route: formOfIncorporationRoute,
        ids: ['#vorherigesUnternehmenUstIdentifikationsnummer']
    } as EricErrorConfig],
    [incorrectSalesTaxUstId, {
        route: salesTaxRoute,
        ids: ['#ustIdentifikationsnummer']
    } as EricErrorConfig],
    [incorrectFormOfIncorporationUstId, {
        route: formOfIncorporationRoute,
        ids: ['#vorherigesUnternehmenUstIdentifikationsnummer']
    } as EricErrorConfig],
    [incorrectOrganizationsUstId, {
        route: organizationsRoute,
        ids: []
    } as EricErrorConfig],
    [invalidOrganizationsUstId, {
        route: organizationsRoute,
        ids: []
    } as EricErrorConfig],
    [invalidGermanOrganizationsUstId, {
        route: organizationsRoute,
        ids: []
    } as EricErrorConfig],
    [emptyOrganizationsParticipation, {
        route: organizationsRoute,
        ids: []
    } as EricErrorConfig],
    [counterGreaterThanDenominator, {
        route: organizationsRoute,
        ids: []
    } as EricErrorConfig],
    [incompleteOrganizationsPOBox, {
        route: organizationsRoute,
        ids: []
    } as EricErrorConfig],
    [incompleteOrganizationsAddress, {
        route: organizationsRoute,
        ids: []
    } as EricErrorConfig],
    [incompleteOrganizationsPOBox, {
        route: organizationsRoute,
        ids: []
    } as EricErrorConfig],
    [emptyOrganizationsCompanyName, {
        route: organizationsRoute,
        ids: []
    } as EricErrorConfig],
    [emptyOperatingSiteAddress, {
        route: operatingSitesRoute,
        ids: []
    } as EricErrorConfig],
    [invalidOperatingSiteTelNumber, {
        route: operatingSitesRoute,
        ids: []
    } as EricErrorConfig],
    [incompleteOperatingSiteTelNumber, {
        route: operatingSitesRoute,
        ids: []
    } as EricErrorConfig],
    [emptyInternationalOperatingSiteAddress, {
        route: operatingSitesRoute,
        ids: []
    } as EricErrorConfig],
    [incorrectOperatingSiteAddress, {
        route: operatingSitesRoute,
        ids: []
    } as EricErrorConfig],
    [noMultipleOperatingSiteAddress, {
        route: operatingSitesRoute,
        ids: []
    } as EricErrorConfig]
]);
